module.exports = __webpack_public_path__ + "img/texturing3.0245d80e.png";